import React, { Component } from 'react';

export default class extends Component<{ onClickNav: () => void }, any> {
  render() {
    // TODO サンプルコードそのままのため、必要に応じて修正してください。
    return (
      <nav className='uc-header uc-header--no-shadow'>
        <div className='uc-header__container'>
          <div className='uc-header__left'>
            <button className='uc-header__nav-button uc-button u-visible--s' onClick={this.props.onClickNav}>
              <i className='material-icons uc-button__icon'>menu</i>
            </button>
            <a className='uc-header__logo' href='/'>
              <h1 className='u-text-primary u-text-bold u-text-2l'>見込顧客管理</h1>
            </a>
          </div>
        </div>
      </nav>
    );
  }
}
